import { useEffect, useContext, useState } from 'react';
import { DataContext } from 'providers/data';
import { Link, useNavigate } from 'react-router-dom';

import { Box, Typography } from '@mui/material';

import { ParamsDataFinancialPending } from 'utils/typeServices';

import Menu from 'components/views/Menu';
import Modals from 'components/views/Modals';
import NavTitle from 'components/views/NavTitle';
import { ButtonRectangle } from 'components/views/form/Button';

import InvoiceContent from 'components/views/Invoices/InvoiceContent';

import { ReactComponent as IcTicket } from 'assets/icons/ic-ticket.svg';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
// import { ReactComponent as IcTheDueDate } from 'assets/icons/ic-the-due-date.svg';
import { ReactComponent as IcChangeCharge } from 'assets/icons/ic-change-charge.svg';
import { ReactComponent as IcPaymentMethod } from 'assets/icons/ic-payment-method.svg';
import { ReactComponent as IcVectorInvoices } from 'assets/icons/ic-vector-invoices.svg';

import IcBannerInvoices from 'assets/images/ic-banner-invoices.png';

import { ContainerBody, ContentBody, BoxCustom, ContentInvoices, LinkExtermal } from './styles';

const Invoices = () => {
    const navigate = useNavigate();
    const { dataFinancialPending, blockClick } = useContext(DataContext);
    const [isExpiredTicket, setIsExpiredTicket] = useState(false);
    const [showModalErrorPendingInvoice, setShowModalErrorPendingInvoice] = useState(false);

    const [nextInvList, setNextInvList] = useState<Array<ParamsDataFinancialPending>>([]);

    const [paidInvList, setPaidInvList] = useState<Array<ParamsDataFinancialPending>>([]);
    const [overdueInvList, setOverdueInvList] = useState<Array<ParamsDataFinancialPending>>([]);

    useEffect(() => {
        if (nextInvList) {
            const dateNow = new Date();
            const expiredTicket = nextInvList.findIndex(({ DT_VENCIMENTO, NR_STATUS }) => (NR_STATUS === 1) && new Date(`${DT_VENCIMENTO.split('/')[2]}/${DT_VENCIMENTO.split('/')[1]}/${DT_VENCIMENTO.split('/')[0]}`).getTime() < dateNow.getTime());
            expiredTicket > 1 && setIsExpiredTicket(true);
        } else {
            setIsExpiredTicket(false);
        }

        if (overdueInvList.length > 1) {
            setIsExpiredTicket(true);
        } else {
            setIsExpiredTicket(false);
        }

    }, [nextInvList, overdueInvList]);

    useEffect(() => {
        if (Array.isArray(dataFinancialPending) && dataFinancialPending?.length > 0) {
            let overdueInvListAux: Array<ParamsDataFinancialPending> = [];
            let nextInvListAux: Array<ParamsDataFinancialPending> = [];
            let paidInvListAux: Array<ParamsDataFinancialPending> = [];
            const dateNow = new Date(new Date().setHours(0, 0, 0, 0));

            dataFinancialPending?.map(({ DT_VENCIMENTO, NR_STATUS }, index) =>
                NR_STATUS === 2 ?
                    paidInvListAux.push(dataFinancialPending[index])
                    :
                    new Date(`${DT_VENCIMENTO.split('/')[2]}/${DT_VENCIMENTO.split('/')[1]}/${DT_VENCIMENTO.split('/')[0]}`).getTime() < dateNow.getTime() ?
                        overdueInvListAux.push(dataFinancialPending[index])
                        :
                        nextInvListAux.push(dataFinancialPending[index])
            );

            setNextInvList(nextInvListAux);
            setPaidInvList(paidInvListAux);
            setOverdueInvList(overdueInvListAux);
        }
    }, [dataFinancialPending]);

    return (
        <Menu>
            <ContainerBody>
                <ContentBody>
                    <Typography fontSize='1.5625rem' fontWeight={700} color='rgba(141, 155, 181, 0.5)' lineHeight='30px' sx={{
                        width: '70%',
                        marginBottom: '1.64rem',
                        borderBottom: '1px solid rgba(141, 155, 181, 0.5)',
                        display: {
                            xs: 'none',
                            md: 'block'
                        }
                    }}>
                        FATURAS
                    </Typography>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}>
                        <Box sx={{
                            display: {
                                xs: 'none',
                                md: 'block'
                            },
                            width: {
                                xs: '100%',
                                md: '70%'
                            }
                        }}>
                            <Box sx={{ backgroundColor: '#1C386B', width: '100%', height: '100%', borderRadius: '.6rem', position: 'relative' }}>
                                <Box sx={{ position: 'absolute', left: '0', height: '100%', display: 'flex', alignItems: 'center', gap: '.2rem' }}>
                                    <IcVectorInvoices />
                                    <IcTicket />
                                    <Box sx={{ textTransform: 'uppercase', paddingLeft: { md: '0', lg: '.5rem' } }}>
                                        <Typography
                                            sx={{
                                                fontSize: {
                                                    md: '1.2rem',
                                                    lg: '1.32rem'
                                                },
                                                color: 'secondary.main',
                                                paddingBottom: '2px'
                                            }}>
                                            Praticidade e segurança!
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: {
                                                    md: '1.25rem',
                                                    lg: '1.38rem'
                                                },
                                                color: 'white',
                                                lineHeight: '1.1'
                                            }}>
                                            pague <b style={{ color: '#17A7E0' }}>também</b> suas faturas <br />
                                            de forma simples no nosso <b>app.</b>
                                        </Typography>
                                    </Box>
                                </Box>
                                <img src={IcBannerInvoices} style={{ position: 'absolute', right: '0', bottom: '0', maxWidth: '190px' }} alt='banner' />
                            </Box>
                        </Box>
                        <Box sx={{
                            width: '30%',
                            display: {
                                xs: 'none',
                                md: 'flex'
                            },
                            alignItems: 'center',
                            flexDirection: 'column',
                            justifyContent: 'start',
                        }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <NavTitle title='Alteração da forma de pagamento' fontSize={{ xs: '.75rem', md: '.85rem' }} height='1.3rem' />
                                <BoxCustom
                                    onClick={() => isExpiredTicket ? setShowModalErrorPendingInvoice(true) : !blockClick && navigate('alterar-pagamento')}
                                    sx={{
                                        opacity: !blockClick ? '1' : '.2',
                                        cursor: !blockClick ? 'pointer' : 'not-allowed'
                                    }}
                                >
                                    <Box sx={{
                                        width: '100%',
                                        height: '48%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <IcChangeCharge />
                                    </Box>
                                    <Box sx={{
                                        width: '100%',
                                        height: '52%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: 'secondary.main',
                                        borderRadius: '0 0 10.6202px 10.6202px'
                                    }}>
                                        <Typography fontSize='.875rem' lineHeight='17px' fontWeight={600} textAlign='center'>
                                            <strong style={{
                                                color: 'white'
                                            }}>Clique e altere:</strong><br />
                                            · Forma de pagamento<br />
                                            {/* · Data de vencimento */}
                                        </Typography>
                                    </Box>
                                </BoxCustom>
                            </Box>
                        </Box>
                    </Box>
                </ContentBody>
                <ContentInvoices>
                    <InvoiceContent typeInvoice='nextInv' invList={nextInvList} />
                    <InvoiceContent typeInvoice='overdueInv' invList={overdueInvList} />
                    <InvoiceContent typeInvoice='paidInv' invList={paidInvList} />
                    <Box sx={{
                        display: {
                            xs: 'flex',
                            md: 'none'
                        },
                        flexDirection: 'column',
                        paddingBottom: '2.5rem',
                    }}>
                        <NavTitle title='Alteração da forma de pagamento' fontSize={{ xs: '1rem', md: '.875rem' }} height='1.5rem' />
                        <Box sx={{
                            display: 'flex',
                            paddingTop: '1rem',
                            justifyContent: 'space-between'
                        }}>
                            <Link
                                to={(!blockClick && !isExpiredTicket) ? '/faturas/alterar-pagamento' : ''}
                                onClick={() => isExpiredTicket && setShowModalErrorPendingInvoice(true)}
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    height: '7rem',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    borderRadius: '11.6837px',
                                    border: '1.30373px solid #0C1C33',
                                    opacity: !blockClick ? '1' : '.2',
                                }}>
                                <IcPaymentMethod />
                                <Typography
                                    fontSize='.75rem'
                                    fontWeight={600}
                                    textAlign='center'
                                    lineHeight='.875rem'
                                    paddingTop='.6975rem'
                                >
                                    Troque a forma de pagamento
                                </Typography>
                            </Link>

                            {/* <Link
                                to={(!blockClick && !isExpiredTicket) ? '/faturas/alterar-pagamento' : ''}
                                onClick={() => isExpiredTicket && setShowModalErrorPendingInvoice(true)}
                                style={{
                                    width: '47%',
                                    display: 'flex',
                                    height: '7.5rem',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    borderRadius: '11.6837px',
                                    border: '1.30373px solid #0C1C33',
                                    opacity: !blockClick ? '1' : '.2',
                                }}>
                                <IcTheDueDate />
                                <Typography
                                    fontSize='.75rem'
                                    fontWeight={600}
                                    textAlign='center'
                                    lineHeight='.875rem'
                                    paddingTop='.6975rem'
                                >
                                    Troque a data de vencimento
                                </Typography>
                            </Link> */}
                        </Box>
                    </Box>
                </ContentInvoices>
            </ContainerBody>

            <Modals open={showModalErrorPendingInvoice}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '25rem' } }}>
                    <Box sx={{ padding: { xs: '1.5rem .3rem .68rem', md: '1.5rem 1.5rem .68rem' }, borderRadius: '8px 8px 0 0', textAlign: 'center' }}>
                        <Typography fontSize='1.56rem' fontWeight={700} lineHeight='20px'>
                            AVISO
                        </Typography>
                        <Typography fontSize='1rem' lineHeight='20px' marginTop='1rem'>
                            <strong>Identificamos que você possui uma pendência em aberto.</strong>
                            &nbsp;A alteração de cobrança
                            só é possível quando não há boletos vencidos.
                            <br />
                            <br />
                            Mas não se preocupe, você pode pegar a
                            segunda via aqui mesmo na área do cliente, no
                            menu "Faturas" ou entrar em contato:
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        backgroundColor: 'primary.main',
                        padding: '2.1875rem 3.81rem 1.875rem',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                            maxWidth: '15.68rem',
                        }
                    }}>
                        <Typography fontSize='.875rem' color='white' paddingBottom='.9375rem' lineHeight='1.3'>
                            Atendimento de Segunda à Sexta das 08h as 18h e aos Sábados das 8h às 14h
                        </Typography>
                        <LinkExtermal href="tel:08007742000">
                            0800 774 2000
                            <LocalPhoneOutlinedIcon />
                        </LinkExtermal>
                        <LinkExtermal href="tel:551136169000">
                            3616 - 9000
                            <LocalPhoneOutlinedIcon />
                        </LinkExtermal>
                        <Typography fontSize='.75rem' margin='-.3rem 0 1rem' color='white' textAlign='center'>
                            Opção 1, 2 e 2
                        </Typography>
                        <ButtonRectangle
                            name='FECHAR'
                            onClick={() => setShowModalErrorPendingInvoice(false)}
                        />
                    </Box>
                </Box>
            </Modals>
        </Menu >
    );
}

export default Invoices;